import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarConcertApplicationStatusDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The Solar Concert application status. Reading never creates a customer or
 * submits credit; the server reconciles a dispatched application with Concert
 * on each read, so the status drawer passes `refetchOnMount: "always"`.
 */
export default function useSolarConcertApplication(
  proposalId: string | undefined,
  {
    enabled = true,
    refetchOnMount = true,
  }: { enabled?: boolean; refetchOnMount?: boolean | `always` } = {},
): UseQueryResult<SolarConcertApplicationStatusDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.concertApplication(proposalId ?? ``),
    queryFn: () => solarProposalService.getConcertApplication(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    retry: 1,
    staleTime: 30_000,
    refetchOnMount,
    refetchOnWindowFocus: false,
  })
}
